import React from 'react'
// https://usehooks.com/usemediaquery
// https://github.com/uidotdev/usehooks/blob/main/index.js

/**
 * Resolve the window media queries should run against.
 *
 * In the Puck editor, canvas components are portaled into an iframe (so their
 * JS runs in the parent realm — `window` is the TOP window, not the iframe).
 * The editor exposes the iframe document at `window.iframeDocument`; using its
 * `defaultView` makes media queries reflect the simulated viewport. This
 * self-heals: once the iframe is gone (e.g. navigating away from /editor)
 * `defaultView` is null, so we fall back to the top window. Production never
 * sets `window.iframeDocument`, so behaviour there is unchanged.
 */
function getActiveWindow() {
  if (typeof window === 'undefined') return undefined
  return window.iframeDocument?.defaultView || window
}

export function useMediaQuery(query) {
  const subscribe = React.useCallback(
    callback => {
      const win = getActiveWindow()
      if (!win?.matchMedia) return () => {}
      const matchMedia = win.matchMedia(query)

      matchMedia.addEventListener('change', callback)
      return () => {
        matchMedia.removeEventListener('change', callback)
      }
    },
    [query],
  )

  const getSnapshot = () => {
    const win = getActiveWindow()
    return win?.matchMedia ? win.matchMedia(query).matches : false
  }

  const getServerSnapshot = () => {
      // throw Error("useMediaQuery is a client-only hook");
      return false; // TODO: better default. This was a hack. https://stackoverflow.com/questions/76608501/error-usemediaquery-is-a-client-only-hook
  }

  return React.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot)
}
